import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

/**
 * Функция обновления/сохранения счетчиков
 */
const useCabinetMetersSave = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()
  const queryClient = useQueryClient()
  const route = useRoute()
  const cabinetId = computed(() => route.params.object_id as string)

  const mutation = useMutation({
    mutationFn: (data: any) => {
      if (data.replace_id) {
        return http.put(`/cabinets/${cabinetId.value}/meters/${data.replace_id}/replace`, data)
      } else if (data.id) {
        return http.put(`/cabinets/${cabinetId.value}/meters/${data.id}`, data)
      } else {
        return http.post(`/cabinets/${cabinetId.value}/meters`, data)
      }
    },
  })

  const save = async (data: any, replace_id?: number) => {
    try {
      /** Нормализуем данные перед отправкой */
      data.tariff_count = Number(data.tariff_count)
      data.ktt = Number(data.ktt)
      data.replace_id = replace_id || 0

      await mutation.mutateAsync(data)

      addSuccess(trs('itf.meter_saved'))

      await queryClient.invalidateQueries({ queryKey: ['load_cabinet_meters', cabinetId] })
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    save,
  }
}

/**
 * Функция удаления счетчика
 * @param cabinet_id
 */
const useCabinetMetersDelete = (cabinet_id: string) => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (meter_id: number) => {
      return http.del(`/cabinets/${cabinet_id}/meters/${meter_id}`)
    },
  })

  const remove = async (meter_id: number) => {
    try {
      await mutation.mutateAsync(meter_id)

      addSuccess(trs('itf.meter_removed'))

      await queryClient.invalidateQueries({ queryKey: ['load_cabinet_meters', cabinet_id] })
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    remove,
  }
}

export { useCabinetMetersSave, useCabinetMetersDelete }
